const ADD_PLACEMENT_DATE_OPTION_IDS = {
    ContractStartDate: 1,
    StartOfMonth: 2,
    Divergent: 3
};

const ADD_PLACEMENT_DATE_OPTIONS = [
    { id: ADD_PLACEMENT_DATE_OPTION_IDS.ContractStartDate, name: 'Startdatum huidig contract' },
    { id: ADD_PLACEMENT_DATE_OPTION_IDS.StartOfMonth, name: 'Begin huidige maand' },
    { id: ADD_PLACEMENT_DATE_OPTION_IDS.Divergent, name: 'Afwijkend' }
];

export {
    ADD_PLACEMENT_DATE_OPTION_IDS,
    ADD_PLACEMENT_DATE_OPTIONS
};